import { render, staticRenderFns } from "./AddTrainee.vue?vue&type=template&id=73bddb82&scoped=true&"
import script from "./AddTrainee.vue?vue&type=script&lang=js&"
export * from "./AddTrainee.vue?vue&type=script&lang=js&"
import style0 from "./AddTrainee.vue?vue&type=style&index=0&id=73bddb82&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bddb82",
  null
  
)

export default component.exports